import type { SVGProps } from "react";
import { forwardRef } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgMoneyFilled = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M19.672 7.416c-.124-.043-.248.053-.248.184v5.86c0 2.503-1.76 4.32-4.186 4.32H5.97a.19.19 0 0 0-.185.248c.429 1.267 1.514 2.062 2.98 2.062h9.776c1.907 0 3.19-1.334 3.19-3.32v-6.23c0-1.532-.81-2.69-2.06-3.124M10.35 9.17a1.176 1.176 0 1 0-.003 2.35 1.176 1.176 0 0 0 .003-2.35"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M14.039 8.11a.75.75 0 0 1 0-1.5h1.181a.75.75 0 0 1 0 1.5zm-3.688 4.91a2.676 2.676 0 0 1-2.677-2.67 2.68 2.68 0 0 1 2.677-2.68 2.675 2.675 0 0 1 0 5.35m-3.692 1.07H5.478a.75.75 0 1 1 0-1.5h1.18a.75.75 0 0 1 0 1.5m11.766-.63V7.23c0-1.985-1.28-3.32-3.186-3.32H5.454C3.58 3.91 2.27 5.277 2.27 7.23v6.23c0 1.956 1.309 3.32 3.183 3.32h9.785c1.904 0 3.185-1.333 3.185-3.32"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgMoneyFilled);
export default ForwardRef;
